/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import type { AxiosRequestConfig } from "axios"
import { env } from '$env/dynamic/public';
import type { FloraInput, FloraOutput } from "./type";
import { chatSession, connectedToAgent, sessionTimeout } from "$lib/stores/chatSessionStore";
import { axiosHandler } from "../axiosHandler";
import { datadogLogs } from "@datadog/browser-logs";
import { get } from "svelte/store";
import { startCreateTimer, stopTimer } from "$lib/utilities/disconnectConversation";

export const sendMessage = async (requestData: FloraInput, token: string): Promise<FloraOutput> => {
    const chatSessionData = get(chatSession)
    const protocol = env.PUBLIC_NODE_ENV === 'dev' ? 'http://' : 'https://'
    const originOrFastlyRoute = env.PUBLIC_ORIGIN_ROUTING ? '/webchat/flora/message' : '/r/api/conversational/garden-webchat-api/flora/message';
    const domain = env.PUBLIC_ORIGIN_ROUTING ? env.PUBLIC_ORIGIN_DOMAIN_URL : env.PUBLIC_DOMAIN_URL
    const route = env.PUBLIC_NODE_ENV === 'dev' ? '/flora/message' : originOrFastlyRoute
    window.parent.postMessage({ type: 'flora-get-access-token' }, '*');
    try {
        const config: AxiosRequestConfig = {
            method: 'POST',
            url: `${protocol}${domain}${route}`,
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`, },
            data: chatSessionData.transferCounter >= 2 ? {
                conversation_id: requestData.conversation_id,
                message: requestData.message,
                type: "text",
                params: { trigger: 'transfer_exec' }
            } : requestData,
            timeout: 30000
        };
        const response = await axiosHandler<{ message: FloraOutput }>(config);
        if (response?.data?.message?.params?.agent) {
            chatSession.update(cs => ({ ...cs, agent: response?.data?.message?.params?.agent as 'flora' | 'sierra' | 'decagon' }))
        }
        if (response?.data?.message?.params?.update_conversation_id) {
            chatSession.update(cs => ({ ...cs, conversation_id: response?.data?.message?.params?.update_conversation_id as string }))
        }
        if (response?.data?.message?.params?.suggestions) {
            response.data.message.params.suggestions = response?.data?.message?.params?.suggestions.slice(0, 3)
        }
        if (!get(connectedToAgent)) {
            startCreateTimer(chatSessionData?.conversation_id)
            datadogLogs.logger.info(`[Conv-ui] Timer Reset - brand: ${requestData.brand_code} browser_uuid: ${chatSessionData?.browseruuid} conversation_id: ${requestData?.conversation_id}`)
        }
        if (response?.data?.message?.params?.session_timeout) {
            sessionTimeout.set(true)
            stopTimer(chatSessionData?.conversation_id) // ends timeout timer since session has already timed out
        }
        if (response?.data?.message?.params?.trigger === 'transfer_exec') {
            connectedToAgent.set(true)
            stopTimer(chatSessionData?.conversation_id) // ends timeout timer since we connect to agent
        }
        if (response?.data?.message?.params?.survey_link) {
            stopTimer(chatSessionData?.conversation_id) //ends timeout timer when we have sent a survey link
        }
        datadogLogs.logger.info(`[Conv-ui] Send Message Success - brand: ${requestData.brand_code} browser_uuid: ${chatSessionData?.browseruuid} conversation_id: ${requestData?.conversation_id} customerMessage: ${requestData?.message} responseMessage: ${JSON.stringify(response?.data?.message?.message)}`)
        return response?.data?.message
    } catch (error) {
        chatSession.update(cs => ({ ...cs, transferCounter: cs.transferCounter + 1 }))
        datadogLogs.logger.error(`[Conv-ui] Send Message Failure - brand: ${requestData.brand_code} browser_uuid: ${chatSessionData?.browseruuid} conversation_id: ${requestData?.conversation_id} error: ${error}`)
        return {
            conversation_id: '',
            message: 'Oops! Something went wrong while sending your message. Please try sending it again, or if you prefer, you can asked to be transferred to a live representative.',
            type: 'text',
            params: { suggestions: [{ suggestion: 'Retry', type: 'errorCatch' }] }
        } as FloraOutput
    }
}